import axios from 'axios'

import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { handleApiError } from '@/utils/apiHelpers'

export function createAccountActions() {
    function sendLink(payload) {
        return axios
            .post('/users/reset-password', payload)
            .then((response) => {
                notificationService.success(t('common.account.passwordResetLinkSent'))

                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, t('common.account.passwordResetLinkFailed'))
                return Promise.reject(error)
            })
    }

    function changePassword({ userId, passwords }) {
        return axios
            .patch(`/users/users/${userId}`, passwords)
            .then((response) => {
                notificationService.success(t('common.account.passwordChanged'))

                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, t('common.account.passwordChangeFailed'))
                return Promise.reject(error)
            })
    }

    function passwordReset(payload) {
        return axios
            .post('/users/password-reset-confirmation', payload)
            .then((response) => {
                notificationService.success(t('common.account.passwordChanged'))

                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, t('common.account.passwordChangeFailed'))
                return Promise.reject(error)
            })
    }

    return {
        sendLink,
        changePassword,
        passwordReset
    }
}
